// Date-filter ranges on US Eastern calendar days (October 2026). Used by the Ready for Interview
// funnel; the server applies the same rules to the table (buildDateFilter in
// routes/candidates.js), so the two always agree. Weeks run Monday to Sunday, "Last 3 Months" is
// the three previous full calendar months, and `to` is exclusive (start of the next day).
const TZ = 'America/New_York';

const fmt = new Intl.DateTimeFormat('en-US', {
  timeZone: TZ, hour12: false, year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', weekday: 'short',
});

function easternParts(date) {
  const p = Object.fromEntries(fmt.formatToParts(date).map(x => [x.type, x.value]));
  return { y: +p.year, m: +p.month, d: +p.day, h: +p.hour % 24, mi: +p.minute, s: +p.second, weekday: p.weekday };
}

// Minutes Eastern is ahead of UTC at that instant (-240 in EDT, -300 in EST)
function offsetMinutes(date) {
  const e = easternParts(date);
  return (Date.UTC(e.y, e.m - 1, e.d, e.h, e.mi, e.s) - Math.floor(date.getTime() / 1000) * 1000) / 60000;
}

// The instant of 00:00 Eastern on a calendar day (month is 1-based; overflow is normalised)
function easternMidnight(y, m, d) {
  const wall = Date.UTC(y, m - 1, d);
  let t = wall - offsetMinutes(new Date(wall)) * 60000;
  t = wall - offsetMinutes(new Date(t)) * 60000; // settle across a DST change
  return new Date(t);
}

const WEEKDAY_INDEX = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };

export function easternRange(dateFilter, startDate, endDate) {
  const t = easternParts(new Date());
  if (dateFilter === 'thisWeek') {
    const mon = t.d - WEEKDAY_INDEX[t.weekday];
    return { from: easternMidnight(t.y, t.m, mon), to: easternMidnight(t.y, t.m, mon + 7) };
  }
  if (dateFilter === 'thisMonth') return { from: easternMidnight(t.y, t.m, 1), to: easternMidnight(t.y, t.m + 1, 1) };
  if (dateFilter === 'lastMonth') return { from: easternMidnight(t.y, t.m - 1, 1), to: easternMidnight(t.y, t.m, 1) };
  if (dateFilter === 'last3Months') return { from: easternMidnight(t.y, t.m - 3, 1), to: easternMidnight(t.y, t.m, 1) };
  if (dateFilter === 'custom' && startDate && endDate) {
    const [sy, sm, sd] = startDate.split('-').map(Number);
    const [ey, em, ed] = endDate.split('-').map(Number);
    return { from: easternMidnight(sy, sm, sd), to: easternMidnight(ey, em, ed + 1) };
  }
  return { from: null, to: null };
}
